import { createAction } from 'redux-actions';

export const getOperationNotificationsRequest = createAction('GET_OPERATION_NOTIFICATIONS_REQUEST');
export const getOperationNotificationsSuccess = createAction('GET_OPERATION_NOTIFICATIONS_SUCCESS');
export const getOperationNotificationsFail = createAction('GET_OPERATION_NOTIFICATIONS_FAIL');

export const newOperationNotifications = createAction('NEW_OPERATION_NOTIFICATIONS');

export const updateOperationNotifications = createAction('UPDATE_OPERATION_NOTIFICATIONS');
